import { Dialog } from '@headlessui/react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { YSButton } from '../../../../components/Buttons';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  onPrepopulate: () => void;
  onManualConfig: () => void;
}

export function WelcomeModal({
  isOpen,
  isLoading,
  onClose,
  onPrepopulate,
  onManualConfig,
}: WelcomeModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md rounded-lg bg-white p-6 shadow-xl">
          <div className="flex items-start gap-4">
            <InformationCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0 mt-1" />
            <div>
              <Dialog.Title className="text-lg font-medium text-gray-900">
                {t('manager.preferencesConfig.welcomeTitle')}
              </Dialog.Title>

              <div className="mt-2 text-sm text-gray-500">
                <p className="mb-4">
                  {t('manager.preferencesConfig.welcomeDescription')}
                </p>
                <p className="mb-4">
                  {t('manager.preferencesConfig.welcomeOptions')}
                  <ul className="list-disc ml-5 mt-2">
                    <li>
                      {t('manager.preferencesConfig.welcomeOptionsPrepopulate')}
                    </li>
                    <li>
                      {t('manager.preferencesConfig.welcomeOptionsManual')}
                    </li>
                  </ul>
                </p>
                <p>{t('manager.preferencesConfig.welcomeOptionsDontWorry')}</p>
              </div>

              <div className="mt-6 flex gap-3">
                <YSButton onClick={onPrepopulate} disabled={isLoading}>
                  {t('manager.preferencesConfig.prepopulate')}
                </YSButton>
                <YSButton
                  onClick={onManualConfig}
                  disabled={isLoading}
                  variant="ghost-primary"
                >
                  {t('manager.preferencesConfig.manualConfig')}
                </YSButton>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
